(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = window.scrollY || window.pageYOffset || 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.onFocusInHandler = this.onFocusIn.bind(this);
      this.onPageShowHandler = this.syncRestoredScroll.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.addEventListener('focusin', this.onFocusInHandler);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('pageshow', this.onPageShowHandler);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.removeEventListener('focusin', this.onFocusInHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('pageshow', this.onPageShowHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    syncRestoredScroll() {
      this.currentScrollTop = window.scrollY || window.pageYOffset || 0;
    }

    onFocusIn(event) {
      if (!this.header.contains(event.target)) return;
      if (!this.header.classList.contains('shopify-section-header-hidden')) return;
      requestAnimationFrame(this.reveal.bind(this));
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky || this.header.classList.contains('hf-home-search-active')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-b06-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-customer-reviews')) return;
  class HeartfeltCustomerReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      if (!this.details || !this.dataset.productId) return;
      this.titleElement = this.details.querySelector('.accordion__title');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.bindSources();
      this.details.querySelector('summary')?.addEventListener('click', () => {
        this.userToggled = true;
      }, { signal });
      document.addEventListener('click', (event) => {
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge)) return;
        this.details.open = true;
        requestAnimationFrame(() => {
          if (this.isConnected) this.details.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      }, { capture: true, signal });
      const refresh = () => { this.bindSources(); this.scheduleSync(); };
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('product-info:loaded', refresh, { signal });
      document.addEventListener('DOMContentLoaded', refresh, { once: true, signal });
      this.onViewportChange = () => this.scheduleSync();
      this.mobile.addEventListener('change', this.onViewportChange);
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.onViewportChange);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    bindSources() {
      this.productRoot = Array.from(document.querySelectorAll('main product-info[data-update-url="true"]'))
        .find((root) => root.dataset.productId === this.dataset.productId) || null;
      this.observer.disconnect();
      const options = {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['data-number-of-reviews', 'data-id', 'data-product-id']
      };
      this.observer.observe(this, options);
      if (this.productRoot) this.observer.observe(this.productRoot, options);
    }

    belongsToProduct(node) {
      if (!this.contains(node) && !this.productRoot?.contains(node)) return false;
      if (node.closest('product-recommendations, quick-add-modal, .card-wrapper, .hf-cart-upsell')) return false;
      const owner = node.closest('[data-product-id]');
      if (owner && owner.dataset.productId !== this.dataset.productId) return false;
      const widget = node.closest('.jdgm-widget[data-id], .jdgm-prev-badge[data-id], .jdgm-rev-widg[data-id], .jdgm-review-widget[data-id]');
      return !widget || !widget.dataset.id || widget.dataset.id === this.dataset.productId;
    }

    parseReviewCount() {
      const serverCount = Number(this.dataset.reviewCount);
      let count = Number.isSafeInteger(serverCount) && serverCount >= 0 ? serverCount : 0;
      [this, this.productRoot].filter(Boolean).forEach((root) => {
        root.querySelectorAll('[data-number-of-reviews]').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const raw = source.getAttribute('data-number-of-reviews') || '';
          const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
        root.querySelectorAll('.jdgm-prev-badge__text').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const match = source.textContent.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          const value = match ? Number(match[1].replace(/,/g, '')) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
      });
      return count;
    }

    scheduleSync() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }

    sync() {
      if (!this.isConnected || !this.details) return;
      const count = this.parseReviewCount();
      if (count > 0 && this.details.dataset.hfHasReviews !== 'true') {
        if (!this.userToggled) this.details.open = true;
        this.details.dataset.hfHasReviews = 'true';
      }
      const label = count > 0 ? `Customer reviews (${count})` : 'Customer reviews';
      if (this.titleElement && this.titleElement.textContent !== label) this.titleElement.textContent = label;
      this.syncDeliveryPlacement();
    }

    // Existing placement is preserved in this batch; moving ownership is a separate logged task.
    syncDeliveryPlacement() {
      const form = this.productRoot?.querySelector('product-form form');
      if (!form) return;
      const card = form.querySelector('.hf-delivery-card');
      const wrapper = card?.closest('.quick-add-hidden') || card;
      const buttons = form.querySelector('.product-form__buttons');
      if (!wrapper || !buttons || wrapper.contains(buttons) || !form.contains(wrapper)) return;
      if (!this.deliveryState || this.deliveryState.wrapper !== wrapper) {
        const marker = document.createComment('hf-delivery-original-position');
        wrapper.before(marker);
        this.deliveryState = { wrapper, marker };
      }
      if (this.mobile.matches) {
        if (buttons.previousElementSibling !== wrapper) buttons.before(wrapper);
      } else if (this.deliveryState.marker.parentNode && this.deliveryState.marker.nextSibling !== wrapper) {
        this.deliveryState.marker.after(wrapper);
      }
    }
  }
  customElements.define('hf-customer-reviews', HeartfeltCustomerReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-browse-gifts-20260915"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-browse-gifts')) {
    customElements.define(
      'hf-browse-gifts',
      class HfBrowseGifts extends HTMLElement {
        connectedCallback() {
          if (!this.initialized) {
            this.initialized = true;
            this.tabs = Array.from(this.querySelectorAll('[data-browse-tab]'));
            this.panels = Array.from(this.querySelectorAll('[data-browse-panel]'));
            this.rails = Array.from(this.querySelectorAll('[data-browse-rail]'));
            this.tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.selectTab(tab.dataset.browseTab, { source: 'user' });
              });
              tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
            });
            this.rails.forEach((rail) => {
              rail.addEventListener('scroll', () => this.updateRail(rail), { passive: true });
            });
            this.popstateListener = () => {
              this.selectTab(this.readTabFromUrl(), { source: 'history' });
            };
          }
          if (!this.popstateListening) {
            window.addEventListener('popstate', this.popstateListener);
            this.popstateListening = true;
          }
          this.selectTab(this.readTabFromUrl(), { source: 'initial' });
          this.startRailObserver();
          requestAnimationFrame(() => this.updateRails());
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.popstateListening) {
            window.removeEventListener('popstate', this.popstateListener);
            this.popstateListening = false;
          }
        }

        startRailObserver() {
          if (!('ResizeObserver' in window)) return;
          if (this.resizeObserver) this.resizeObserver.disconnect();
          this.resizeObserver = new ResizeObserver(() => this.updateRails());
          this.resizeObserver.observe(this);
        }

        updateRail(rail) {
          const hasOverflow = rail.scrollWidth - rail.clientWidth > 2;
          const atEnd = !hasOverflow || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
          rail.dataset.hasOverflow = hasOverflow ? 'true' : 'false';
          rail.dataset.atEnd = atEnd ? 'true' : 'false';
        }

        updateRails() {
          this.rails.forEach((rail) => this.updateRail(rail));
        }

        readTabFromUrl() {
          const requestedKey = new URL(window.location.href).searchParams.get('browse');
          const defaultKey = this.tabs.some((tab) => tab.dataset.browseTab === this.dataset.defaultTab)
            ? this.dataset.defaultTab
            : this.tabs[0]?.dataset.browseTab;
          return this.tabs.some((tab) => tab.dataset.browseTab === requestedKey)
            ? requestedKey
            : defaultKey;
        }

        writeTabToUrl(key) {
          const url = new URL(window.location.href);
          url.searchParams.set('browse', key);
          window.history.pushState({}, '', url);
        }

        selectTab(key, { moveFocus = false, source = 'programmatic' } = {}) {
          const selectedTab = this.tabs.find((tab) => tab.dataset.browseTab === key);
          if (!selectedTab) return;
          const update = () => {
            this.tabs.forEach((tab) => {
              const active = tab.dataset.browseTab === key;
              tab.setAttribute('aria-selected', active ? 'true' : 'false');
              tab.tabIndex = active ? 0 : -1;
            });
            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.browsePanel !== key;
            });
          };

          update();
          requestAnimationFrame(() => this.updateRails());
          if (source === 'user') this.writeTabToUrl(key);
          if (moveFocus && selectedTab) selectedTab.focus();
        }

        onKeydown(event, tab) {
          const index = this.tabs.indexOf(tab);
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          this.selectTab(this.tabs[nextIndex].dataset.browseTab, {
            moveFocus: true,
            source: 'user',
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-controls-customer-reviews-20260915"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-customer-reviews')) return;

  class HeartfeltCustomerReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      if (!this.details || !this.dataset.productId) return;

      this.titleElement = this.details.querySelector('.accordion__title');
      this.reviewRegionId = this.querySelector('.hf-customer-reviews__content')?.id || this.details.id;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.bindSources();

      this.details.querySelector('summary')?.addEventListener('click', () => {
        this.userToggled = true;
      }, { signal });

      this.details.addEventListener('toggle', () => this.syncBadgeState(), { signal });

      document.addEventListener('click', (event) => {
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge)) return;
        this.openReviews();
      }, { capture: true, signal });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge) || this.isNativeInteractive(badge)) return;
        event.preventDefault();
        this.openReviews();
      }, { capture: true, signal });

      const refresh = () => { this.bindSources(); this.scheduleSync(); };
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('product-info:loaded', refresh, { signal });
      document.addEventListener('DOMContentLoaded', refresh, { once: true, signal });
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    bindSources() {
      this.productRoot = Array.from(document.querySelectorAll('main product-info[data-update-url="true"]'))
        .find((root) => root.dataset.productId === this.dataset.productId) || null;
      this.observer.disconnect();
      const options = {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-number-of-reviews', 'data-id', 'data-product-id']
      };
      this.observer.observe(this, options);
      if (this.productRoot) this.observer.observe(this.productRoot, options);
    }

    belongsToProduct(node) {
      if (!this.contains(node) && !this.productRoot?.contains(node)) return false;
      if (node.closest('product-recommendations, quick-add-modal, .card-wrapper, .hf-cart-upsell')) return false;
      const owner = node.closest('[data-product-id]');
      if (owner && owner.dataset.productId !== this.dataset.productId) return false;
      const widget = node.closest('.jdgm-widget[data-id], .jdgm-prev-badge[data-id], .jdgm-rev-widg[data-id], .jdgm-review-widget[data-id]');
      return !widget || !widget.dataset.id || widget.dataset.id === this.dataset.productId;
    }

    getPreviewBadges() {
      return Array.from(this.productRoot?.querySelectorAll('.jdgm-prev-badge') || [])
        .filter((badge) => this.belongsToProduct(badge));
    }

    isNativeInteractive(badge) {
      return badge.matches('a[href], button, input, select, textarea, summary');
    }

    enhanceBadges() {
      this.getPreviewBadges().forEach((badge) => {
        if (!this.isNativeInteractive(badge)) {
          if (!badge.hasAttribute('role')) badge.setAttribute('role', 'button');
          if (!badge.hasAttribute('tabindex')) badge.setAttribute('tabindex', '0');
        }
        badge.setAttribute('aria-controls', this.reviewRegionId);
        if (!badge.hasAttribute('aria-label')) badge.setAttribute('aria-label', 'Read customer reviews');
      });
    }

    syncBadgeState() {
      this.getPreviewBadges().forEach((badge) => {
        badge.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
      });
    }

    openReviews() {
      this.details.open = true;
      this.syncBadgeState();
      requestAnimationFrame(() => {
        if (this.isConnected) this.details.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }

    parseReviewCount() {
      const serverCount = Number(this.dataset.reviewCount);
      let count = Number.isSafeInteger(serverCount) && serverCount >= 0 ? serverCount : 0;

      [this, this.productRoot].filter(Boolean).forEach((root) => {
        root.querySelectorAll('[data-number-of-reviews]').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const raw = source.getAttribute('data-number-of-reviews') || '';
          const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });

        root.querySelectorAll('.jdgm-prev-badge__text').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const match = source.textContent.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          const value = match ? Number(match[1].replace(/,/g, '')) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
      });

      return count;
    }

    scheduleSync() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        this.sync();
      });
    }

    sync() {
      if (!this.isConnected || !this.details) return;
      const count = this.parseReviewCount();
      if (count > 0 && this.details.dataset.hfHasReviews !== 'true') {
        if (!this.userToggled) this.details.open = true;
        this.details.dataset.hfHasReviews = 'true';
      }
      const label = count > 0 ? `Customer reviews (${count})` : 'Customer reviews';
      if (this.titleElement && this.titleElement.textContent !== label) this.titleElement.textContent = label;
      this.enhanceBadges();
      this.syncBadgeState();
    }
  }

  customElements.define('hf-customer-reviews', HeartfeltCustomerReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-controls-header-20260915"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = window.scrollY || window.pageYOffset || 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.onFocusInHandler = this.onFocusIn.bind(this);
      this.onPageShowHandler = this.syncRestoredScroll.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.addEventListener('focusin', this.onFocusInHandler);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('pageshow', this.onPageShowHandler);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.removeEventListener('focusin', this.onFocusInHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('pageshow', this.onPageShowHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    syncRestoredScroll() {
      this.currentScrollTop = window.scrollY || window.pageYOffset || 0;
    }

    onFocusIn(event) {
      if (!this.header.contains(event.target)) return;
      if (!this.header.classList.contains('shopify-section-header-hidden')) return;
      requestAnimationFrame(this.reveal.bind(this));
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-controls-product-shelves-20260915"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-product-shelves')) {
    customElements.define(
      'hf-product-shelves',
      class HfProductShelves extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';
          this.tabs = Array.from(this.querySelectorAll('[data-shelf-tab]'));
          this.panels = Array.from(this.querySelectorAll('[data-shelf-panel]'));
          this.tabList = this.querySelector('[role="tablist"]');
          this.tabCue = this.querySelector('.hf-shelves__tabs-cue');
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.selectTab(tab.dataset.shelfTab));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
          });
          this.addEventListener('shopify:block:select', (event) => {
            const panel = event.target.closest('[data-shelf-panel]');
            if (panel) this.selectTab(panel.dataset.shelfPanel);
          });
          if (this.tabList && this.tabCue) {
            this.tabList.addEventListener('scroll', () => this.updateTabCue(), { passive: true });
            this.tabCueResizeObserver = new ResizeObserver(() => this.updateTabCue());
            this.tabCueResizeObserver.observe(this.tabList);
            requestAnimationFrame(() => this.updateTabCue());
          }
        }

        updateTabCue() {
          if (!this.tabList || !this.tabCue) return;
          const tolerance = 2;
          const maxScroll = Math.max(0, this.tabList.scrollWidth - this.tabList.clientWidth);
          const scrollLeft = Math.min(maxScroll, Math.max(0, this.tabList.scrollLeft));
          this.tabCue.hidden = maxScroll <= tolerance || maxScroll - scrollLeft <= tolerance;
        }

        selectTab(key, moveFocus = false) {
          const selectedTab = this.tabs.find((tab) => tab.dataset.shelfTab === key);
          let activePanel = null;
          this.tabs.forEach((tab) => {
            const active = tab.dataset.shelfTab === key;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel) => {
            const active = panel.dataset.shelfPanel === key;
            panel.hidden = !active;
            if (active) activePanel = panel;
          });
          if (selectedTab) {
            if (moveFocus) selectedTab.focus({ preventScroll: true });
            const tabList = selectedTab.closest('[role="tablist"]');
            if (tabList && tabList.scrollWidth > tabList.clientWidth) {
              const visibleStart = tabList.scrollLeft;
              const visibleEnd = visibleStart + tabList.clientWidth;
              const tabStart = selectedTab.offsetLeft;
              const tabEnd = tabStart + selectedTab.offsetWidth;
              let nextScrollLeft = visibleStart;
              if (tabStart < visibleStart) nextScrollLeft = tabStart;
              // Align a clipped tab to its own snap point. Calculating the
              // smallest possible delta can snap back to the previous tab,
              // especially on mobile where the tab list reserves room for
              // the directional cue.
              if (tabEnd > visibleEnd) nextScrollLeft = tabStart;
              requestAnimationFrame(() => {
                tabList.scrollTo({
                  left: nextScrollLeft,
                  behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
                });
              });
            }
          }
          if (activePanel) {
            this.hydratePanel(activePanel);
            requestAnimationFrame(() => {
              const slider = activePanel.querySelector('slider-component');
              if (slider && typeof slider.resetPages === 'function') slider.resetPages();
            });
          }
        }

        // Inactive tabs ship their cards inside an inert <template> so they cost
        // no layout or image decoding on first load. Move them into the rail the
        // first time the tab is opened; resetPages() then wires the slider.
        hydratePanel(panel) {
          const deferred = panel.querySelector('template[data-shelf-deferred]');
          if (!deferred) return;
          const rail = panel.querySelector('.hf-shelves__rail');
          if (!rail) return;
          rail.appendChild(deferred.content.cloneNode(true));
          deferred.remove();
        }

        onKeydown(event, tab) {
          const index = this.tabs.indexOf(tab);
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (nextIndex === index) return;
          this.selectTab(this.tabs[nextIndex].dataset.shelfTab, true);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-customer-reviews-20260916"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-customer-reviews')) return;
  class HeartfeltCustomerReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      if (!this.details || !this.dataset.productId) return;
      this.titleElement = this.details.querySelector('.accordion__title');
      this.reviewRegionId = this.querySelector('.hf-customer-reviews__content')?.id || this.details.id;
      this.baseHeading = this.dataset.heading || 'Customer reviews';
      this.autoOpen = this.dataset.autoOpen === 'true';
      this.showCount = this.dataset.showCount === 'true';
      this.hideEmpty = this.dataset.hideEmpty === 'true';
      this.badgeStyle = this.dataset.badgeStyle || 'pill';
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.bindSources();
      this.details.querySelector('summary')?.addEventListener('click', () => { this.userToggled = true; }, { signal });
      this.details.addEventListener('toggle', () => this.syncBadgeState(), { signal });
      document.addEventListener('click', (event) => {
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge)) return;
        this.openReviews();
      }, { capture:true, signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge) || this.isNativeInteractive(badge)) return;
        event.preventDefault();
        this.openReviews();
      }, { capture:true, signal });
      const refresh = () => { this.bindSources(); this.scheduleSync(); };
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('product-info:loaded', refresh, { signal });
      document.addEventListener('DOMContentLoaded', refresh, { once:true, signal });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    bindSources() {
      this.productRoot = Array.from(document.querySelectorAll('main product-info[data-update-url="true"]')).find((root) => root.dataset.productId === this.dataset.productId) || null;
      this.observer.disconnect();
      const options = { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['data-number-of-reviews','data-id','data-product-id'] };
      this.observer.observe(this, options);
      if (this.productRoot) this.observer.observe(this.productRoot, options);
    }
    belongsToProduct(node) {
      if (!this.contains(node) && !this.productRoot?.contains(node)) return false;
      if (node.closest('product-recommendations, quick-add-modal, .card-wrapper, .hf-cart-upsell')) return false;
      const owner = node.closest('[data-product-id]');
      if (owner && owner.dataset.productId !== this.dataset.productId) return false;
      const widget = node.closest('.jdgm-widget[data-id], .jdgm-prev-badge[data-id], .jdgm-rev-widg[data-id], .jdgm-review-widget[data-id]');
      return !widget || !widget.dataset.id || widget.dataset.id === this.dataset.productId;
    }
    getPreviewBadges() { return Array.from(this.productRoot?.querySelectorAll('.jdgm-prev-badge') || []).filter((badge) => this.belongsToProduct(badge)); }
    isNativeInteractive(badge) { return badge.matches('a[href], button, input, select, textarea, summary'); }
    enhanceBadges() {
      this.getPreviewBadges().forEach((badge) => {
        if (!this.isNativeInteractive(badge)) {
          if (!badge.hasAttribute('role')) badge.setAttribute('role','button');
          if (!badge.hasAttribute('tabindex')) badge.setAttribute('tabindex','0');
        }
        badge.setAttribute('aria-controls', this.reviewRegionId);
        if (!badge.hasAttribute('aria-label')) badge.setAttribute('aria-label','Read customer reviews');
        badge.classList.toggle('hf-jdgm-badge--plain', this.badgeStyle === 'plain');
      });
    }
    syncBadgeState() { this.getPreviewBadges().forEach((badge) => badge.setAttribute('aria-expanded', this.details.open ? 'true':'false')); }
    openReviews() {
      this.hidden = false;
      this.details.open = true;
      this.syncBadgeState();
      requestAnimationFrame(() => { if (this.isConnected) this.details.scrollIntoView({ behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto':'smooth', block:'start' }); });
    }
    parseReviewCount() {
      const serverCount = Number(this.dataset.reviewCount);
      let count = Number.isSafeInteger(serverCount) && serverCount >= 0 ? serverCount : 0;
      [this, this.productRoot].filter(Boolean).forEach((root) => {
        root.querySelectorAll('[data-number-of-reviews]').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const raw = source.getAttribute('data-number-of-reviews') || '';
          const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
        root.querySelectorAll('.jdgm-prev-badge__text').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const match = source.textContent.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          const value = match ? Number(match[1].replace(/,/g,'')) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
      });
      return count;
    }
    scheduleSync() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }
    sync() {
      if (!this.isConnected || !this.details) return;
      const count = this.parseReviewCount();
      this.hidden = this.hideEmpty && count === 0;
      if (count > 0 && this.details.dataset.hfHasReviews !== 'true') {
        if (this.autoOpen && !this.userToggled) this.details.open = true;
        this.details.dataset.hfHasReviews = 'true';
      }
      const label = this.showCount && count > 0 ? `${this.baseHeading} (${count})` : this.baseHeading;
      if (this.titleElement && this.titleElement.textContent !== label) this.titleElement.textContent = label;
      this.enhanceBadges();
      this.syncBadgeState();
    }
  }
  customElements.define('hf-customer-reviews', HeartfeltCustomerReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-delivery-decouple-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-customer-reviews')) return;
  class HeartfeltCustomerReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      if (!this.details || !this.dataset.productId) return;
      this.titleElement = this.details.querySelector('.accordion__title');
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.bindSources();
      this.details.querySelector('summary')?.addEventListener('click', () => {
        this.userToggled = true;
      }, { signal });
      document.addEventListener('click', (event) => {
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge)) return;
        this.details.open = true;
        requestAnimationFrame(() => {
          if (this.isConnected) this.details.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      }, { capture: true, signal });
      const refresh = () => { this.bindSources(); this.scheduleSync(); };
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('product-info:loaded', refresh, { signal });
      document.addEventListener('DOMContentLoaded', refresh, { once: true, signal });
      this.onViewportChange = () => this.scheduleSync();
      this.mobile.addEventListener('change', this.onViewportChange);
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      this.mobile?.removeEventListener('change', this.onViewportChange);
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }

    bindSources() {
      this.productRoot = Array.from(document.querySelectorAll('main product-info[data-update-url="true"]'))
        .find((root) => root.dataset.productId === this.dataset.productId) || null;
      this.observer.disconnect();
      const options = {
        childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['data-number-of-reviews', 'data-id', 'data-product-id']
      };
      this.observer.observe(this, options);
      if (this.productRoot) this.observer.observe(this.productRoot, options);
    }

    belongsToProduct(node) {
      if (!this.contains(node) && !this.productRoot?.contains(node)) return false;
      if (node.closest('product-recommendations, quick-add-modal, .card-wrapper, .hf-cart-upsell')) return false;
      const owner = node.closest('[data-product-id]');
      if (owner && owner.dataset.productId !== this.dataset.productId) return false;
      const widget = node.closest('.jdgm-widget[data-id], .jdgm-prev-badge[data-id], .jdgm-rev-widg[data-id], .jdgm-review-widget[data-id]');
      return !widget || !widget.dataset.id || widget.dataset.id === this.dataset.productId;
    }

    parseReviewCount() {
      const serverCount = Number(this.dataset.reviewCount);
      let count = Number.isSafeInteger(serverCount) && serverCount >= 0 ? serverCount : 0;
      [this, this.productRoot].filter(Boolean).forEach((root) => {
        root.querySelectorAll('[data-number-of-reviews]').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const raw = source.getAttribute('data-number-of-reviews') || '';
          const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
        root.querySelectorAll('.jdgm-prev-badge__text').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const match = source.textContent.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          const value = match ? Number(match[1].replace(/,/g, '')) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
      });
      return count;
    }

    scheduleSync() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }

    sync() {
      if (!this.isConnected || !this.details) return;
      const count = this.parseReviewCount();
      if (count > 0 && this.details.dataset.hfHasReviews !== 'true') {
        if (!this.userToggled) this.details.open = true;
        this.details.dataset.hfHasReviews = 'true';
      }
      const label = count > 0 ? `Customer reviews (${count})` : 'Customer reviews';
      if (this.titleElement && this.titleElement.textContent !== label) this.titleElement.textContent = label;
      this.syncDeliveryPlacement();
    }

    // Existing placement is preserved in this batch; moving ownership is a separate logged task.
    syncDeliveryPlacement() {
      const form = this.productRoot?.querySelector('product-form form');
      if (!form) return;
      const card = form.querySelector('.hf-delivery-card');
      const wrapper = card?.closest('.quick-add-hidden') || card;
      const buttons = form.querySelector('.product-form__buttons');
      if (!wrapper || !buttons || wrapper.contains(buttons) || !form.contains(wrapper)) return;
      if (!this.deliveryState || this.deliveryState.wrapper !== wrapper) {
        const marker = document.createComment('hf-delivery-original-position');
        wrapper.before(marker);
        this.deliveryState = { wrapper, marker };
      }
      if (this.mobile.matches) {
        if (buttons.previousElementSibling !== wrapper) buttons.before(wrapper);
      } else if (this.deliveryState.marker.parentNode && this.deliveryState.marker.nextSibling !== wrapper) {
        this.deliveryState.marker.after(wrapper);
      }
    }
  }
  customElements.define('hf-customer-reviews', HeartfeltCustomerReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-next-browse-gifts-20260915"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-browse-gifts')) {
    customElements.define(
      'hf-browse-gifts',
      class HfBrowseGifts extends HTMLElement {
        connectedCallback() {
          if (!this.initialized) {
            this.initialized = true;
            this.tabs = Array.from(this.querySelectorAll('[data-browse-tab]'));
            this.panels = Array.from(this.querySelectorAll('[data-browse-panel]'));
            this.rails = Array.from(this.querySelectorAll('[data-browse-rail]'));
            this.tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.selectTab(tab.dataset.browseTab, { source: 'user' });
              });
              tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
            });
            this.rails.forEach((rail) => {
              rail.addEventListener('scroll', () => this.updateRail(rail), { passive: true });
            });
            this.popstateListener = () => {
              this.selectTab(this.readTabFromUrl(), { source: 'history' });
            };
          }
          if (!this.popstateListening) {
            window.addEventListener('popstate', this.popstateListener);
            this.popstateListening = true;
          }
          this.selectTab(this.readTabFromUrl(), { source: 'initial' });
          this.startRailObserver();
          requestAnimationFrame(() => this.updateRails());
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.popstateListening) {
            window.removeEventListener('popstate', this.popstateListener);
            this.popstateListening = false;
          }
        }

        startRailObserver() {
          if (!('ResizeObserver' in window)) return;
          if (this.resizeObserver) this.resizeObserver.disconnect();
          this.resizeObserver = new ResizeObserver(() => this.updateRails());
          this.resizeObserver.observe(this);
        }

        updateRail(rail) {
          const hasOverflow = rail.scrollWidth - rail.clientWidth > 2;
          const atEnd = !hasOverflow || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
          rail.dataset.hasOverflow = hasOverflow ? 'true' : 'false';
          rail.dataset.atEnd = atEnd ? 'true' : 'false';
        }

        updateRails() {
          this.rails.forEach((rail) => this.updateRail(rail));
        }

        readTabFromUrl() {
          const requestedKey = new URL(window.location.href).searchParams.get('browse');
          const defaultKey = this.tabs.some((tab) => tab.dataset.browseTab === this.dataset.defaultTab)
            ? this.dataset.defaultTab
            : this.tabs[0]?.dataset.browseTab;
          return this.tabs.some((tab) => tab.dataset.browseTab === requestedKey)
            ? requestedKey
            : defaultKey;
        }

        writeTabToUrl(key) {
          const url = new URL(window.location.href);
          url.searchParams.set('browse', key);
          window.history.pushState({}, '', url);
        }

        selectTab(key, { moveFocus = false, source = 'programmatic' } = {}) {
          const selectedTab = this.tabs.find((tab) => tab.dataset.browseTab === key);
          if (!selectedTab) return;
          const update = () => {
            this.tabs.forEach((tab) => {
              const active = tab.dataset.browseTab === key;
              tab.setAttribute('aria-selected', active ? 'true' : 'false');
              tab.tabIndex = active ? 0 : -1;
            });
            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.browsePanel !== key;
            });
          };

          update();
          requestAnimationFrame(() => this.updateRails());
          if (source === 'user') this.writeTabToUrl(key);
          if (moveFocus && selectedTab) selectedTab.focus();
        }

        onKeydown(event, tab) {
          const index = this.tabs.indexOf(tab);
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          this.selectTab(this.tabs[nextIndex].dataset.browseTab, {
            moveFocus: true,
            source: 'user',
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-backup-reviews-20260919"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-customer-reviews')) return;
  class HeartfeltCustomerReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      if (!this.details || !this.dataset.productId) return;
      this.titleElement = this.details.querySelector('.accordion__title');
      this.reviewRegionId = this.querySelector('.hf-customer-reviews__content')?.id || this.details.id;
      this.baseHeading = this.dataset.heading || 'Customer reviews';
      this.autoOpen = this.dataset.autoOpen === 'true';
      this.showCount = this.dataset.showCount === 'true';
      this.hideEmpty = this.dataset.hideEmpty === 'true';
      this.badgeStyle = this.dataset.badgeStyle || 'plain';
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.bindSources();
      this.details.querySelector('summary')?.addEventListener('click', () => { this.userToggled = true; }, { signal });
      this.details.addEventListener('toggle', () => this.syncBadgeState(), { signal });
      document.addEventListener('click', (event) => {
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge)) return;
        this.openReviews();
      }, { capture: true, signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge) || this.isNativeInteractive(badge)) return;
        event.preventDefault();
        this.openReviews();
      }, { capture: true, signal });
      const refresh = () => { this.bindSources(); this.scheduleSync(); };
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('product-info:loaded', refresh, { signal });
      document.addEventListener('DOMContentLoaded', refresh, { once: true, signal });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    bindSources() {
      this.productRoot = Array.from(document.querySelectorAll('main product-info[data-update-url="true"]')).find((root) => root.dataset.productId === this.dataset.productId) || null;
      this.observer.disconnect();
      const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-id', 'data-product-id'] };
      this.observer.observe(this, options);
      if (this.productRoot) this.observer.observe(this.productRoot, options);
    }
    belongsToProduct(node) {
      if (!this.contains(node) && !this.productRoot?.contains(node)) return false;
      if (node.closest('product-recommendations, quick-add-modal, .card-wrapper, .hf-cart-upsell')) return false;
      const owner = node.closest('[data-product-id]');
      if (owner && owner.dataset.productId !== this.dataset.productId) return false;
      const widget = node.closest('.jdgm-widget[data-id], .jdgm-prev-badge[data-id], .jdgm-rev-widg[data-id], .jdgm-review-widget[data-id]');
      return !widget || !widget.dataset.id || widget.dataset.id === this.dataset.productId;
    }
    getPreviewBadges() {
      return Array.from(this.productRoot?.querySelectorAll('.jdgm-prev-badge') || []).filter((badge) => this.belongsToProduct(badge));
    }
    isNativeInteractive(badge) { return badge.matches('a[href], button, input, select, textarea, summary'); }
    enhanceBadges() {
      this.getPreviewBadges().forEach((badge) => {
        if (!this.isNativeInteractive(badge)) {
          if (!badge.hasAttribute('role')) badge.setAttribute('role', 'button');
          if (!badge.hasAttribute('tabindex')) badge.setAttribute('tabindex', '0');
        }
        badge.setAttribute('aria-controls', this.reviewRegionId);
        if (!badge.hasAttribute('aria-label')) badge.setAttribute('aria-label', 'Read customer reviews');
        badge.classList.toggle('hf-jdgm-badge--plain', this.badgeStyle === 'plain');
      });
    }
    syncBadgeState() {
      this.getPreviewBadges().forEach((badge) => badge.setAttribute('aria-expanded', this.details.open ? 'true' : 'false'));
    }
    openReviews() {
      this.hidden = false;
      this.details.open = true;
      this.syncBadgeState();
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.details.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
    parseReviewCount() {
      const serverCount = Number(this.dataset.reviewCount);
      let count = Number.isSafeInteger(serverCount) && serverCount >= 0 ? serverCount : 0;
      [this, this.productRoot].filter(Boolean).forEach((root) => {
        root.querySelectorAll('[data-number-of-reviews]').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const raw = source.getAttribute('data-number-of-reviews') || '';
          const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
        root.querySelectorAll('.jdgm-prev-badge__text').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const match = source.textContent.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          const value = match ? Number(match[1].replace(/,/g, '')) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
      });
      return count;
    }
    scheduleSync() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }
    sync() {
      if (!this.isConnected || !this.details) return;
      const count = this.parseReviewCount();
      this.hidden = this.hideEmpty && count === 0;
      if (count > 0 && this.details.dataset.hfHasReviews !== 'true') {
        if (this.autoOpen && !this.userToggled) this.details.open = true;
        this.details.dataset.hfHasReviews = 'true';
      }
      const label = this.showCount && count > 0 ? `${this.baseHeading} (${count})` : this.baseHeading;
      if (this.titleElement && this.titleElement.textContent !== label) this.titleElement.textContent = label;
      this.enhanceBadges();
      this.syncBadgeState();
    }
  }
  customElements.define('hf-customer-reviews', HeartfeltCustomerReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-browse-gifts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-browse-gifts')) {
    customElements.define(
      'hf-browse-gifts',
      class HfBrowseGifts extends HTMLElement {
        connectedCallback() {
          if (!this.initialized) {
            this.initialized = true;
            this.tabs = Array.from(this.querySelectorAll('[data-browse-tab]'));
            this.panels = Array.from(this.querySelectorAll('[data-browse-panel]'));
            this.rails = Array.from(this.querySelectorAll('[data-browse-rail]'));
            this.setupDynamicHeader();
            this.tabs.forEach((tab) => {
              tab.addEventListener('click', () => {
                this.selectTab(tab.dataset.browseTab, { source: 'user' });
              });
              tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
            });
            this.rails.forEach((rail) => {
              rail.addEventListener('scroll', () => this.updateRail(rail), { passive: true });
            });
            this.popstateListener = () => {
              this.selectTab(this.readTabFromUrl(), { source: 'history' });
            };
          }
          if (!this.popstateListening) {
            window.addEventListener('popstate', this.popstateListener);
            this.popstateListening = true;
          }
          this.selectTab(this.readTabFromUrl(), { source: 'initial' });
          this.startRailObserver();
          requestAnimationFrame(() => this.updateRails());
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
          if (this.popstateListening) {
            window.removeEventListener('popstate', this.popstateListener);
            this.popstateListening = false;
          }
        }

        /* HF browse header restoration 2026-09-18 */
        setupDynamicHeader() {
          if (this.dataset.browseDynamicHeading !== 'true') return;
          this.heading = this.querySelector('.hf-browse__heading');
          this.headingWrap = this.querySelector('.hf-browse__heading-wrap');
          if (!this.heading || !this.headingWrap) return;
          this.dynamicAllLink = document.createElement('a');
          this.dynamicAllLink.className = 'hf-browse__dynamic-all link underlined-link animate-arrow';
          this.dynamicAllLink.innerHTML = '<span></span><span aria-hidden="true">→</span>';
          this.headingWrap.appendChild(this.dynamicAllLink);
          this.syncDynamicHeader(this.dataset.defaultTab || 'recipient');
        }

        syncDynamicHeader(key) {
          if (!this.heading || !this.dynamicAllLink) return;
          const map = {
            recipient: ['Shop by recipient', 'View all', '/collections#directory-recipient'],
            occasion: ['Shop by occasion', 'View all', '/collections#directory-occasion'],
            product: ['Shop by gift type', 'View all', '/collections#directory-product']
          };
          const item = map[key] || map.recipient;
          this.heading.textContent = item[0];
          this.dynamicAllLink.querySelector('span').textContent = item[1];
          this.dynamicAllLink.href = item[2];
          this.querySelectorAll('.hf-browse__panel-footer').forEach((footer) => footer.hidden = true);
        }

        startRailObserver() {
          if (!('ResizeObserver' in window)) return;
          if (this.resizeObserver) this.resizeObserver.disconnect();
          this.resizeObserver = new ResizeObserver(() => this.updateRails());
          this.resizeObserver.observe(this);
        }

        updateRail(rail) {
          const hasOverflow = rail.scrollWidth - rail.clientWidth > 2;
          const atEnd = !hasOverflow || rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
          rail.dataset.hasOverflow = hasOverflow ? 'true' : 'false';
          rail.dataset.atEnd = atEnd ? 'true' : 'false';
        }

        updateRails() {
          this.rails.forEach((rail) => this.updateRail(rail));
        }

        readTabFromUrl() {
          const requestedKey = new URL(window.location.href).searchParams.get('browse');
          const defaultKey = this.tabs.some((tab) => tab.dataset.browseTab === this.dataset.defaultTab)
            ? this.dataset.defaultTab
            : this.tabs[0]?.dataset.browseTab;
          return this.tabs.some((tab) => tab.dataset.browseTab === requestedKey)
            ? requestedKey
            : defaultKey;
        }

        writeTabToUrl(key) {
          const url = new URL(window.location.href);
          if (url.searchParams.get('browse') === key) return;
          url.searchParams.set('browse', key);
          window.history.pushState(window.history.state, '', url);
        }

        selectTab(key, { moveFocus = false, source = 'programmatic' } = {}) {
          const selectedTab = this.tabs.find((tab) => tab.dataset.browseTab === key);
          if (!selectedTab) return;
          const changed = this.activeTabKey !== key;
          this.activeTabKey = key;
          const update = () => {
            this.tabs.forEach((tab) => {
              const active = tab.dataset.browseTab === key;
              tab.setAttribute('aria-selected', active ? 'true' : 'false');
              tab.tabIndex = active ? 0 : -1;
            });
            this.panels.forEach((panel) => {
              panel.hidden = panel.dataset.browsePanel !== key;
            });
            this.syncDynamicHeader(key);
          };

          update();
          if (changed) {
            const activePanel = this.panels.find((panel) => panel.dataset.browsePanel === key);
            const rail = activePanel?.querySelector('[data-browse-rail]');
            if (rail) rail.scrollLeft = 0;
          }
          requestAnimationFrame(() => this.updateRails());
          if (source === 'user' && changed) this.writeTabToUrl(key);
          if (moveFocus && selectedTab) selectedTab.focus();
        }

        onKeydown(event, tab) {
          const index = this.tabs.indexOf(tab);
          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          this.selectTab(this.tabs[nextIndex].dataset.browseTab, {
            moveFocus: true,
            source: 'user',
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-customer-reviews')) return;
  class HeartfeltCustomerReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      if (!this.details || !this.dataset.productId) return;
      this.titleElement = this.details.querySelector('.accordion__title');
      this.reviewRegionId = this.querySelector('.hf-customer-reviews__content')?.id || this.details.id;
      this.baseHeading = this.dataset.heading || 'Customer reviews';
      this.autoOpen = this.dataset.autoOpen === 'true';
      this.showCount = this.dataset.showCount === 'true';
      this.hideEmpty = this.dataset.hideEmpty === 'true';
      this.badgeStyle = this.dataset.badgeStyle || 'plain';
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.bindSources();
      this.details.querySelector('summary')?.addEventListener('click', () => { this.userToggled = true; }, { signal });
      this.details.addEventListener('toggle', () => this.syncBadgeState(), { signal });
      document.addEventListener('click', (event) => {
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge)) return;
        this.openReviews();
      }, { capture: true, signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge) || this.isNativeInteractive(badge)) return;
        event.preventDefault();
        this.openReviews();
      }, { capture: true, signal });
      const refresh = () => { this.bindSources(); this.scheduleSync(); };
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('product-info:loaded', refresh, { signal });
      document.addEventListener('DOMContentLoaded', refresh, { once: true, signal });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    bindSources() {
      this.productRoot = Array.from(document.querySelectorAll('main product-info[data-update-url="true"]')).find((root) => root.dataset.productId === this.dataset.productId) || null;
      this.observer.disconnect();
      const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-id', 'data-product-id'] };
      this.observer.observe(this, options);
      if (this.productRoot) this.observer.observe(this.productRoot, options);
    }
    belongsToProduct(node) {
      if (!this.contains(node) && !this.productRoot?.contains(node)) return false;
      if (node.closest('product-recommendations, quick-add-modal, .card-wrapper, .hf-cart-upsell')) return false;
      const owner = node.closest('[data-product-id]');
      if (owner && owner.dataset.productId !== this.dataset.productId) return false;
      const widget = node.closest('.jdgm-widget[data-id], .jdgm-prev-badge[data-id], .jdgm-rev-widg[data-id], .jdgm-review-widget[data-id]');
      return !widget || !widget.dataset.id || widget.dataset.id === this.dataset.productId;
    }
    getPreviewBadges() {
      return Array.from(this.productRoot?.querySelectorAll('.jdgm-prev-badge') || []).filter((badge) => this.belongsToProduct(badge));
    }
    isNativeInteractive(badge) { return badge.matches('a[href], button, input, select, textarea, summary'); }
    enhanceBadges() {
      this.getPreviewBadges().forEach((badge) => {
        if (!this.isNativeInteractive(badge)) {
          if (!badge.hasAttribute('role')) badge.setAttribute('role', 'button');
          if (!badge.hasAttribute('tabindex')) badge.setAttribute('tabindex', '0');
        }
        badge.setAttribute('aria-controls', this.reviewRegionId);
        if (!badge.hasAttribute('aria-label')) badge.setAttribute('aria-label', 'Read customer reviews');
        badge.classList.toggle('hf-jdgm-badge--plain', this.badgeStyle === 'plain');
      });
    }
    syncBadgeState() {
      this.getPreviewBadges().forEach((badge) => badge.setAttribute('aria-expanded', this.details.open ? 'true' : 'false'));
    }
    openReviews() {
      this.hidden = false;
      this.details.open = true;
      this.syncBadgeState();
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.details.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
    parseReviewCount() {
      const serverCount = Number(this.dataset.reviewCount);
      let count = Number.isSafeInteger(serverCount) && serverCount >= 0 ? serverCount : 0;
      [this, this.productRoot].filter(Boolean).forEach((root) => {
        root.querySelectorAll('[data-number-of-reviews]').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const raw = source.getAttribute('data-number-of-reviews') || '';
          const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
        root.querySelectorAll('.jdgm-prev-badge__text').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const match = source.textContent.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          const value = match ? Number(match[1].replace(/,/g, '')) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
      });
      return count;
    }
    scheduleSync() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }
    sync() {
      if (!this.isConnected || !this.details) return;
      const count = this.parseReviewCount();
      this.hidden = this.hideEmpty && count === 0;
      if (count > 0 && this.details.dataset.hfHasReviews !== 'true') {
        if (this.autoOpen && !this.userToggled) this.details.open = true;
        this.details.dataset.hfHasReviews = 'true';
      }
      const label = this.showCount && count > 0 ? `${this.baseHeading} (${count})` : this.baseHeading;
      if (this.titleElement && this.titleElement.textContent !== label) this.titleElement.textContent = label;
      this.classList.toggle('hf-review-count-single', count === 1);
      this.enhanceBadges();
      this.syncBadgeState();
    }
  }
  customElements.define('hf-customer-reviews', HeartfeltCustomerReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-judgeme-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-live-reviews')) return;

  class HfLiveReviews extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') {
        this.observeSizes();
        this.resize();
        return;
      }

      this.source = this.querySelector('[data-review-source]');
      this.viewport = this.querySelector('[data-review-viewport]');
      const template = this.querySelector('[data-review-card]');
      this.controls = this.querySelector('[data-review-controls]');
      this.prev = this.querySelector('[data-review-prev]');
      this.next = this.querySelector('[data-review-next]');
      this.position = this.querySelector('[data-review-position]');
      this.status = this.querySelector('[data-review-status]');
      this.reviews = this.readReviews().sort((a, b) => Number(a.isShopReview) - Number(b.isShopReview));
      if (!this.reviews.length || !template || !this.viewport) {
        this.hidden = true;
        return;
      }

      this.index = 0;
      this.cards = this.reviews.map((review, index) => this.createCard(template, review, index));
      this.viewport.replaceChildren(...this.cards);
      this.dataset.ready = 'true';
      this.dataset.navigation = 'native-scroll';
      this.prev?.addEventListener('click', () => this.show(this.index - 1));
      this.next?.addEventListener('click', () => this.show(this.index + 1));
      this.viewport.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.syncFromScroll();
        });
      }, { passive: true });
      this.viewport.addEventListener('touchstart', (event) => {
        this.finishScroll(true);
        this.touching = event.touches.length > 0;
        this.gesture = event.touches.length === 1 ? { index: this.index, kind: 'touch' } : null;
        this.lastWheelAt = 0;
      }, { passive: true });
      const releaseTouch = (event) => {
        this.touching = event.touches.length > 0;
        this.scheduleSettle();
      };
      this.viewport.addEventListener('touchend', releaseTouch, { passive: true });
      this.viewport.addEventListener('touchcancel', releaseTouch, { passive: true });
      this.viewport.addEventListener('wheel', (event) => {
        if (event.ctrlKey || Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
        const now = performance.now();
        if (this.gesture?.kind !== 'wheel' || now - this.lastWheelAt > 240) {
          this.finishScroll(true);
          this.gesture = { index: this.index, kind: 'wheel' };
        }
        this.lastWheelAt = now;
        this.scheduleSettle();
      }, { passive: true });
      this.viewport.addEventListener('scrollend', () => this.finishScroll());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          this.show(this.index + (event.key === 'ArrowRight' ? direction : -direction));
        }
      });

      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.observeSizes();
      document.fonts?.ready.then(() => this.resize());
      this.controls.hidden = this.reviews.length < 2;
      this.setActive(0, false);
      requestAnimationFrame(() => this.resize());
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.resetScroll();
    }

    resetScroll() {
      clearTimeout(this.settleTimer);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
      this.gesture = null;
      this.touching = false;
      this.lastWheelAt = 0;
    }

    observeSizes() {
      if (!this.resizeObserver || !this.viewport) return;
      this.resizeObserver.observe(this.viewport);
      this.cards.forEach((card) => this.resizeObserver.observe(card));
    }

    resize() {
      if (!this.isConnected || !this.cards?.length) return;
      this.cards.forEach((card) => this.updateDisclosure(card));
      const width = this.viewport.clientWidth;
      if (width !== this.viewportWidth) {
        this.resetScroll();
        this.viewportWidth = width;
        this.alignActive();
      }
    }

    alignActive() {
      const card = this.cards?.[this.index];
      if (!card) return;
      this.viewport.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'auto' });
    }

    syncFromScroll() {
      if (!this.isConnected) return;
      this.limitScroll();
      this.scheduleSettle();
    }

    limitScroll() {
      if (!this.gesture) return;
      const first = this.cards[Math.max(0, this.gesture.index - 1)].offsetLeft - this.cards[0].offsetLeft;
      const last = this.cards[Math.min(this.cards.length - 1, this.gesture.index + 1)].offsetLeft - this.cards[0].offsetLeft;
      const bounded = Math.max(Math.min(first, last), Math.min(Math.max(first, last), this.viewport.scrollLeft));
      if (Math.abs(this.viewport.scrollLeft - bounded) > 1) {
        this.viewport.scrollTo({ left: bounded, behavior: 'instant' });
      }
    }

    scheduleSettle() {
      clearTimeout(this.settleTimer);
      if (!this.touching) this.settleTimer = setTimeout(() => this.finishScroll(), 180);
    }

    finishScroll(force = false) {
      if (!this.isConnected || !this.cards?.length) return;
      clearTimeout(this.settleTimer);
      if (!force && (this.touching || (this.gesture?.kind === 'wheel' && performance.now() - this.lastWheelAt < 180))) {
        this.scheduleSettle();
        return;
      }
      this.limitScroll();
      const nearest = this.nearestIndex();
      if (nearest !== this.index) this.setActive(nearest);
      this.alignActive();
    }

    nearestIndex() {
      const viewport = this.viewport.getBoundingClientRect();
      const rtl = getComputedStyle(this).direction === 'rtl';
      let nearest = this.index;
      let distance = Infinity;
      this.cards.forEach((card, index) => {
        const bounds = card.getBoundingClientRect();
        const gap = Math.abs(rtl ? bounds.right - viewport.right : bounds.left - viewport.left);
        if (gap < distance) {
          nearest = index;
          distance = gap;
        }
      });
      return nearest;
    }

    setActive(index, announce = true) {
      const previous = this.cards[this.index];
      if (index !== this.index) {
        if (previous.contains(document.activeElement)) this.viewport.focus({ preventScroll: true });
        this.setExpanded(previous, false);
      }
      this.index = index;
      this.cards.forEach((card, cardIndex) => {
        const active = cardIndex === index;
        card.setAttribute('aria-hidden', String(!active));
        card.querySelectorAll('a, button').forEach((control) => { control.tabIndex = active ? 0 : -1; });
      });
      if (this.position) this.position.textContent = `${index + 1} / ${this.cards.length}`;
      if (announce && this.status) this.status.textContent = `Review ${index + 1} of ${this.cards.length}`;
    }

    show(index, announce = true) {
      if (!this.cards?.length) return;
      this.resetScroll();
      this.setActive((index + this.cards.length) % this.cards.length, announce);
      this.alignActive();
    }

    updateDisclosure(card) {
      if (!this.isConnected) return;
      const body = card.querySelector('[data-review-body]');
      const readMore = card.querySelector('[data-review-read-more]');
      const wasFocused = document.activeElement === readMore;
      readMore.hidden = readMore.getAttribute('aria-expanded') !== 'true' && body.scrollHeight <= body.clientHeight + 1;
      if (readMore.hidden && wasFocused) this.viewport.focus({ preventScroll: true });
    }

    setExpanded(card, expanded) {
      const body = card.querySelector('[data-review-body]');
      const readMore = card.querySelector('[data-review-read-more]');
      body.classList.toggle('is-expanded', Boolean(expanded));
      readMore.setAttribute('aria-expanded', String(Boolean(expanded)));
      readMore.textContent = expanded ? this.dataset.readLessLabel : this.dataset.readMoreLabel;
      this.updateDisclosure(card);
    }

    createCard(template, review, index) {
      const card = template.cloneNode(true);
      const body = card.querySelector('[data-review-body]');
      const readMore = card.querySelector('[data-review-read-more]');
      const reviewer = card.querySelector('[data-reviewer-name]');
      const title = card.querySelector('[data-review-product-title]');
      const image = card.querySelector('[data-review-image]');
      const cta = card.querySelector('[data-review-cta]');
      const ctaLabel = card.querySelector('[data-review-cta-label]');
      card.hidden = false;
      card.dataset.reviewIndex = index;
      card.querySelector('[data-review-stars]').textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
      body.id = `${body.id}-${index + 1}`;
      body.textContent = review.body;
      readMore.setAttribute('aria-controls', body.id);
      readMore.addEventListener('click', () => this.setExpanded(card, readMore.getAttribute('aria-expanded') !== 'true'));
      reviewer.textContent = review.reviewer || 'Customer review';
      card.setAttribute('aria-label', this.dataset.reviewLabel.replace('[name]', reviewer.textContent).replace('[rating]', review.rating));

      if (!review.isShopReview && review.imageAlt) {
        title.textContent = review.imageAlt;
        title.hidden = false;
      }
      if (!review.isShopReview && review.imageUrl) {
        const imageUrl = this.reviewImageUrl(review.imageUrl);
        if (imageUrl !== review.imageUrl) image.dataset.fallbackSrc = review.imageUrl;
        image.addEventListener('error', () => {
          const fallback = image.dataset.fallbackSrc;
          delete image.dataset.fallbackSrc;
          if (fallback) image.src = fallback;
          else image.hidden = true;
        });
        image.src = imageUrl;
        image.alt = review.imageAlt || 'Reviewed personalised gift';
        image.hidden = false;
      }
      const destination = review.isShopReview ? this.dataset.shopUrl : review.productUrl;
      const label = review.isShopReview ? this.dataset.shopLabel : this.dataset.productLabel;
      if (destination) {
        cta.href = destination;
        cta.setAttribute('aria-label', review.isShopReview || !review.imageAlt ? label : `${label}: ${review.imageAlt}`);
        ctaLabel.textContent = label;
        cta.hidden = false;
      }
      return card;
    }

    readReviews() {
      const content = this.source?.content;
      if (!content) return [];

      return Array.from(content.querySelectorAll('.jdgm-carousel-item')).map((item) => {
        const ratingNode = item.querySelector('.jdgm-carousel-item__review-rating');
        const ratingLabel = ratingNode?.getAttribute('aria-label') || '';
        const ratingFromLabel = Number(ratingLabel.match(/\d+(?:\.\d+)?/)?.[0] || 0);
        const ratingFromStars = item.querySelectorAll('.jdgm-star.jdgm--on').length;
        const body = (item.querySelector('.jdgm-carousel-item__review-body')?.textContent || '').replace(/\s+/g, ' ').trim();
        const reviewer = (item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent || '').replace(/\s+/g, ' ').trim();
        const image = item.querySelector('.jdgm-carousel-item__product-image');
        const imageUrl = image?.getAttribute('data-src') || image?.getAttribute('src') || '';
        const imageAlt = (image?.getAttribute('alt') || '').trim();
        const isShopReview = item.classList.contains('jdgm--shop-review');

        return {
          rating: Math.max(1, Math.min(5, Math.round(ratingFromLabel || ratingFromStars || 5))),
          body,
          reviewer,
          imageUrl,
          imageAlt,
          isShopReview,
          productUrl: isShopReview ? '' : this.productUrlFor(imageAlt, item)
        };
      }).filter((review) => review.body || review.reviewer);
    }

    reviewImageUrl(source) {
      try {
        const url = new URL(source, window.location.origin);
        if (url.hostname !== 'cdn.shopify.com' && !(url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/'))) return source;
        url.pathname = url.pathname.replace(/_(?:\d+x\d*|x\d+)(?=\.(?:jpe?g|png|webp|gif|avif)$)/i, '');
        url.searchParams.set('width', '336');
        url.searchParams.delete('height');
        return url.href;
      } catch (_) {
        return source;
      }
    }

    productUrlFor(title, item) {
      const sourceLink = item.querySelector('.jdgm-carousel-item__product a[href]');
      if (sourceLink) {
        try {
          const url = new URL(sourceLink.getAttribute('href'), window.location.origin);
          if (url.origin === window.location.origin && /\/products\/[^/]+\/?$/.test(url.pathname)) {
            return url.pathname + url.search + url.hash;
          }
        } catch (_) {}
      }

      const value = String(title || '').trim();
      if (!value) return '';

      const known = {
        'Personalised Big Number Multi Photo Upload Black Poster Frame': '/products/personalised-big-number-multi-photo-upload-black-poster-frame',
        'Personalised Little Hearts Diamond Effect Vase': '/products/personalised-little-hearts-diamond-effect-vase'
      };
      const root = String(this.dataset.rootUrl || '/').replace(/\/$/, '');
      return known[value] ? root + known[value] : '';
    }
  }

  customElements.define('hf-live-reviews', HfLiveReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-monthly-birthdays"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (customElements.get('hf-monthly-birthdays')) return;
  const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  const parseMonth = (value) => {
    if (!/^(?:[1-9]|1[0-2])$/.test(String(value))) return null;
    return Number(value);
  };
  class HFMonthlyBirthdays extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._refresh = () => this.refresh();
      // The callback can run before the HTML parser has finished this element.
      this._init = () => {
        if (!this._connected) return;
        this._monthCard = this.querySelector('[data-hfmb-month-card]');
        this._host = this._monthCard?.querySelector('[data-hfmb-month-host]');
        this.refresh();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this._init, {once:true});
      } else {
        queueMicrotask(this._init);
      }
      window.addEventListener('pageshow', this._refresh);
      document.addEventListener('visibilitychange', this._refresh);
      document.addEventListener('hf:seasonal-schedule-ready', this._refresh);
      document.addEventListener('hf:seasonal-schedule-change', this._refresh);
      this._timer = window.setInterval(() => {
        if (document.visibilityState !== 'hidden') this.refresh();
      }, 60000);
    }
    disconnectedCallback() {
      this._connected = false;
      window.clearInterval(this._timer);
      window.removeEventListener('pageshow', this._refresh);
      document.removeEventListener('visibilitychange', this._refresh);
      document.removeEventListener('hf:seasonal-schedule-ready', this._refresh);
      document.removeEventListener('hf:seasonal-schedule-change', this._refresh);
      document.removeEventListener('DOMContentLoaded', this._init);
      this._renderedMonth = null;
    }
    resolveMonth(date = new Date()) {
      const editor = this.dataset.designMode === 'true' && window.Shopify?.designMode === true;
      const preview = editor ? parseMonth(this.dataset.editorMonth) : null;
      const fixed = parseMonth(this.dataset.fixedMonth);
      if (preview || fixed) return preview || fixed;
      const calendar = window.HFSeasonalSchedule?.state;
      if (calendar && this.dataset.timezone !== 'UTC') {
        const sharedMonth = parseMonth(calendar.date.slice(5, 7).replace(/^0/, ''));
        if (sharedMonth) return sharedMonth;
      }
      for (const zone of [this.dataset.timezone || 'Europe/London', 'Europe/London']) {
        try {
          const parts = new Intl.DateTimeFormat('en-GB', {timeZone:zone, month:'numeric'}).formatToParts(date);
          const month = parseMonth(parts.find(part => part.type === 'month')?.value);
          if (month) return month;
        } catch (_) { /* Invalid timezone or unsupported Intl: keep a usable fallback. */ }
      }
      return parseMonth(this.dataset.activeMonth) || date.getUTCMonth() + 1;
    }
    refresh(date = new Date()) {
      if (!this._connected || !this.querySelector('[data-hfmb-heading]')) return;
      // Resolve DOM nodes again if the editor replaced a block in place.
      this._monthCard = this.querySelector('[data-hfmb-month-card]');
      this._host = this._monthCard?.querySelector('[data-hfmb-month-host]');
      const month = this.resolveMonth(date);
      if (this._renderedMonth !== month) {
        const name = MONTHS[month - 1];
        for (const [selector, key] of [
          ['[data-hfmb-heading]', 'headingTemplate'],
          ['[data-hfmb-subheading]', 'subheadingTemplate'],
          ['[data-hfmb-eyebrow]', 'eyebrowTemplate']
        ]) {
          const node = this.querySelector(selector);
          if (node) node.textContent = (this.dataset[key] || '').split('[month]').join(name);
        }
        const template = this._monthCard?.querySelector(`template[data-hfmb-month="${month}"]`);
        if (template && this._host) {
          const restoreFocus = this._host.contains(document.activeElement);
          // Avoid replacing identical SSR content on the initial load.
          if (Number(this.dataset.activeMonth) !== month || this._renderedMonth) {
            this._host.replaceChildren(template.content.cloneNode(true));
          }
          this._monthCard.hidden = template.dataset.available !== 'true';
          if (restoreFocus) this._host.querySelector('a')?.focus({preventScroll:true});
        }
        this.dataset.activeMonth = String(month);
        this._renderedMonth = month;
      }
      const count = [...this.querySelectorAll('[data-hfmb-item]')].filter(item => !item.hidden).length;
      this.style.setProperty('--hfmb-columns', String(Math.max(count, 1)));
      this.hidden = count === 0 && this.dataset.designMode !== 'true';
    }
  }
  customElements.define('hf-monthly-birthdays', HFMonthlyBirthdays);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-product-shelves"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-product-shelves')) {
    customElements.define('hf-product-shelves', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-shelf-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-shelf-panel]'));
        this.tabList = this.querySelector('[role="tablist"]');
        this.cue = this.querySelector('.hf-shelves__tabs-cue');
        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.selectTab(tab.dataset.shelfTab));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, tab));
        });
        this.querySelectorAll('[data-shelf-prev],[data-shelf-next]').forEach((button) => {
          button.addEventListener('click', () => this.scrollRail(button, button.hasAttribute('data-shelf-next') ? 1 : -1));
        });
        if (this.tabList && this.cue) {
          this.tabList.addEventListener('scroll', () => this.updateCue(), { passive:true });
          new ResizeObserver(() => this.updateCue()).observe(this.tabList);
          requestAnimationFrame(() => this.updateCue());
        }
      }
      hydrate(panel) {
        const campaign = panel?.querySelector('template[data-campaign-deferred]');
        if (campaign) {
          panel.replaceChildren(campaign.content.cloneNode(true));
          return;
        }
        const template = panel?.querySelector('template[data-shelf-deferred]');
        const rail = panel?.querySelector('.hf-shelves__rail');
        if (!template || !rail) return;
        rail.appendChild(template.content.cloneNode(true));
        template.remove();
      }
      selectTab(key, focus = false) {
        const selected = this.tabs.find((tab) => tab.dataset.shelfTab === key);
        let activePanel = null;
        this.tabs.forEach((tab) => { const active = tab.dataset.shelfTab === key; tab.setAttribute('aria-selected', active ? 'true':'false'); tab.tabIndex = active ? 0:-1; });
        this.panels.forEach((panel) => { const active = panel.dataset.shelfPanel === key; panel.hidden = !active; if (active) activePanel = panel; });
        this.hydrate(activePanel);
        if (selected) { if (focus) selected.focus({preventScroll:true}); selected.scrollIntoView({behavior:'smooth', block:'nearest', inline:'nearest'}); }
        this.updateCue();
      }
      onKeydown(event, tab) {
        const keys = ['ArrowRight','ArrowLeft','Home','End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        const index = this.tabs.indexOf(tab);
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        this.selectTab(this.tabs[next].dataset.shelfTab, true);
      }
      scrollRail(button, direction) {
        const panel = button.closest('.hf-shelves__panel');
        const rail = panel?.querySelector('.hf-shelves__rail');
        if (!rail) return;
        rail.scrollBy({left: direction * Math.max(220, rail.clientWidth * .78), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto':'smooth'});
      }
      updateCue() {
        if (!this.tabList || !this.cue) return;
        const max = Math.max(0, this.tabList.scrollWidth - this.tabList.clientWidth);
        this.cue.hidden = max <= 2 || max - this.tabList.scrollLeft <= 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-reviews-bak-1609b"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-customer-reviews')) return;
  class HeartfeltCustomerReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      if (!this.details || !this.dataset.productId) return;
      this.titleElement = this.details.querySelector('.accordion__title');
      this.reviewRegionId = this.querySelector('.hf-customer-reviews__content')?.id || this.details.id;
      this.baseHeading = this.dataset.heading || 'Customer reviews';
      this.autoOpen = this.dataset.autoOpen === 'true';
      this.showCount = this.dataset.showCount === 'true';
      this.hideEmpty = this.dataset.hideEmpty === 'true';
      this.badgeStyle = this.dataset.badgeStyle || 'plain';
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.bindSources();
      this.details.querySelector('summary')?.addEventListener('click', () => { this.userToggled = true; }, { signal });
      this.details.addEventListener('toggle', () => this.syncBadgeState(), { signal });
      document.addEventListener('click', (event) => {
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge)) return;
        this.openReviews();
      }, { capture: true, signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge) || this.isNativeInteractive(badge)) return;
        event.preventDefault();
        this.openReviews();
      }, { capture: true, signal });
      const refresh = () => { this.bindSources(); this.scheduleSync(); };
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('product-info:loaded', refresh, { signal });
      document.addEventListener('DOMContentLoaded', refresh, { once: true, signal });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    bindSources() {
      this.productRoot = Array.from(document.querySelectorAll('main product-info[data-update-url="true"]')).find((root) => root.dataset.productId === this.dataset.productId) || null;
      this.observer.disconnect();
      const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-id', 'data-product-id'] };
      this.observer.observe(this, options);
      if (this.productRoot) this.observer.observe(this.productRoot, options);
    }
    belongsToProduct(node) {
      if (!this.contains(node) && !this.productRoot?.contains(node)) return false;
      if (node.closest('product-recommendations, quick-add-modal, .card-wrapper, .hf-cart-upsell')) return false;
      const owner = node.closest('[data-product-id]');
      if (owner && owner.dataset.productId !== this.dataset.productId) return false;
      const widget = node.closest('.jdgm-widget[data-id], .jdgm-prev-badge[data-id], .jdgm-rev-widg[data-id], .jdgm-review-widget[data-id]');
      return !widget || !widget.dataset.id || widget.dataset.id === this.dataset.productId;
    }
    getPreviewBadges() {
      return Array.from(this.productRoot?.querySelectorAll('.jdgm-prev-badge') || []).filter((badge) => this.belongsToProduct(badge));
    }
    isNativeInteractive(badge) { return badge.matches('a[href], button, input, select, textarea, summary'); }
    enhanceBadges() {
      this.getPreviewBadges().forEach((badge) => {
        if (!this.isNativeInteractive(badge)) {
          if (!badge.hasAttribute('role')) badge.setAttribute('role', 'button');
          if (!badge.hasAttribute('tabindex')) badge.setAttribute('tabindex', '0');
        }
        badge.setAttribute('aria-controls', this.reviewRegionId);
        if (!badge.hasAttribute('aria-label')) badge.setAttribute('aria-label', 'Read customer reviews');
        badge.classList.toggle('hf-jdgm-badge--plain', this.badgeStyle === 'plain');
      });
    }
    syncBadgeState() {
      this.getPreviewBadges().forEach((badge) => badge.setAttribute('aria-expanded', this.details.open ? 'true' : 'false'));
    }
    openReviews() {
      this.hidden = false;
      this.details.open = true;
      this.syncBadgeState();
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.details.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
    parseReviewCount() {
      const serverCount = Number(this.dataset.reviewCount);
      let count = Number.isSafeInteger(serverCount) && serverCount >= 0 ? serverCount : 0;
      [this, this.productRoot].filter(Boolean).forEach((root) => {
        root.querySelectorAll('[data-number-of-reviews]').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const raw = source.getAttribute('data-number-of-reviews') || '';
          const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
        root.querySelectorAll('.jdgm-prev-badge__text').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const match = source.textContent.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          const value = match ? Number(match[1].replace(/,/g, '')) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
      });
      return count;
    }
    scheduleSync() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }
    sync() {
      if (!this.isConnected || !this.details) return;
      const count = this.parseReviewCount();
      this.hidden = this.hideEmpty && count === 0;
      if (count > 0 && this.details.dataset.hfHasReviews !== 'true') {
        if (this.autoOpen && !this.userToggled) this.details.open = true;
        this.details.dataset.hfHasReviews = 'true';
      }
      const label = this.showCount && count > 0 ? `${this.baseHeading} (${count})` : this.baseHeading;
      if (this.titleElement && this.titleElement.textContent !== label) this.titleElement.textContent = label;
      this.enhanceBadges();
      this.syncBadgeState();
    }
  }
  customElements.define('hf-customer-reviews', HeartfeltCustomerReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-reviews-bak-1609c"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hf-customer-reviews')) return;
  class HeartfeltCustomerReviews extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.details = this.querySelector('details');
      if (!this.details || !this.dataset.productId) return;
      this.titleElement = this.details.querySelector('.accordion__title');
      this.reviewRegionId = this.querySelector('.hf-customer-reviews__content')?.id || this.details.id;
      this.baseHeading = this.dataset.heading || 'Customer reviews';
      this.autoOpen = this.dataset.autoOpen === 'true';
      this.showCount = this.dataset.showCount === 'true';
      this.hideEmpty = this.dataset.hideEmpty === 'true';
      this.badgeStyle = this.dataset.badgeStyle || 'plain';
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.observer = new MutationObserver(() => this.scheduleSync());
      this.bindSources();
      this.details.querySelector('summary')?.addEventListener('click', () => { this.userToggled = true; }, { signal });
      this.details.addEventListener('toggle', () => this.syncBadgeState(), { signal });
      document.addEventListener('click', (event) => {
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge)) return;
        this.openReviews();
      }, { capture: true, signal });
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const badge = event.target instanceof Element ? event.target.closest('.jdgm-prev-badge') : null;
        if (!badge || !this.belongsToProduct(badge) || this.isNativeInteractive(badge)) return;
        event.preventDefault();
        this.openReviews();
      }, { capture: true, signal });
      const refresh = () => { this.bindSources(); this.scheduleSync(); };
      document.addEventListener('shopify:section:load', refresh, { signal });
      document.addEventListener('product-info:loaded', refresh, { signal });
      document.addEventListener('DOMContentLoaded', refresh, { once: true, signal });
      this.sync();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
    bindSources() {
      this.productRoot = Array.from(document.querySelectorAll('main product-info[data-update-url="true"]')).find((root) => root.dataset.productId === this.dataset.productId) || null;
      this.observer.disconnect();
      const options = { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-number-of-reviews', 'data-id', 'data-product-id'] };
      this.observer.observe(this, options);
      if (this.productRoot) this.observer.observe(this.productRoot, options);
    }
    belongsToProduct(node) {
      if (!this.contains(node) && !this.productRoot?.contains(node)) return false;
      if (node.closest('product-recommendations, quick-add-modal, .card-wrapper, .hf-cart-upsell')) return false;
      const owner = node.closest('[data-product-id]');
      if (owner && owner.dataset.productId !== this.dataset.productId) return false;
      const widget = node.closest('.jdgm-widget[data-id], .jdgm-prev-badge[data-id], .jdgm-rev-widg[data-id], .jdgm-review-widget[data-id]');
      return !widget || !widget.dataset.id || widget.dataset.id === this.dataset.productId;
    }
    getPreviewBadges() {
      return Array.from(this.productRoot?.querySelectorAll('.jdgm-prev-badge') || []).filter((badge) => this.belongsToProduct(badge));
    }
    isNativeInteractive(badge) { return badge.matches('a[href], button, input, select, textarea, summary'); }
    enhanceBadges() {
      this.getPreviewBadges().forEach((badge) => {
        if (!this.isNativeInteractive(badge)) {
          if (!badge.hasAttribute('role')) badge.setAttribute('role', 'button');
          if (!badge.hasAttribute('tabindex')) badge.setAttribute('tabindex', '0');
        }
        badge.setAttribute('aria-controls', this.reviewRegionId);
        if (!badge.hasAttribute('aria-label')) badge.setAttribute('aria-label', 'Read customer reviews');
        badge.classList.toggle('hf-jdgm-badge--plain', this.badgeStyle === 'plain');
      });
    }
    syncBadgeState() {
      this.getPreviewBadges().forEach((badge) => badge.setAttribute('aria-expanded', this.details.open ? 'true' : 'false'));
    }
    openReviews() {
      this.hidden = false;
      this.details.open = true;
      this.syncBadgeState();
      requestAnimationFrame(() => {
        if (!this.isConnected) return;
        this.details.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    }
    parseReviewCount() {
      const serverCount = Number(this.dataset.reviewCount);
      let count = Number.isSafeInteger(serverCount) && serverCount >= 0 ? serverCount : 0;
      [this, this.productRoot].filter(Boolean).forEach((root) => {
        root.querySelectorAll('[data-number-of-reviews]').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const raw = source.getAttribute('data-number-of-reviews') || '';
          const value = /^\d+$/.test(raw) ? Number(raw) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
        root.querySelectorAll('.jdgm-prev-badge__text').forEach((source) => {
          if (!this.belongsToProduct(source)) return;
          const match = source.textContent.match(/\b(\d[\d,]*)\s+reviews?\b/i);
          const value = match ? Number(match[1].replace(/,/g, '')) : NaN;
          if (Number.isSafeInteger(value)) count = Math.max(count, value);
        });
      });
      return count;
    }
    scheduleSync() {
      if (this.frame || !this.isConnected) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.sync(); });
    }
    sync() {
      if (!this.isConnected || !this.details) return;
      const count = this.parseReviewCount();
      this.hidden = this.hideEmpty && count === 0;
      if (count > 0 && this.details.dataset.hfHasReviews !== 'true') {
        if (this.autoOpen && !this.userToggled) this.details.open = true;
        this.details.dataset.hfHasReviews = 'true';
      }
      const label = this.showCount && count > 0 ? `${this.baseHeading} (${count})` : this.baseHeading;
      if (this.titleElement && this.titleElement.textContent !== label) this.titleElement.textContent = label;
      this.enhanceBadges();
      this.syncBadgeState();
    }
  }
  customElements.define('hf-customer-reviews', HeartfeltCustomerReviews);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-seasonal-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-seasonal-spotlight')) {
    customElements.define('hf-seasonal-spotlight', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.originals = new Map();
        const signal = this.controller.signal;
        this.refresh = () => this.update();
        document.addEventListener('hf:seasonal-schedule-ready', this.refresh, { signal });
        document.addEventListener('hf:seasonal-schedule-change', this.refresh, { signal });
        document.addEventListener('shopify:section:load', this.refresh, { signal });
        document.addEventListener('DOMContentLoaded', this.refresh, { signal });
        document.addEventListener('focusout', () => queueMicrotask(this.refresh), { signal });
        document.addEventListener('shopify:block:select', (event) => {
          if (!window.Shopify?.designMode) return;
          const source = [...this.querySelectorAll('[data-campaign-source]')].find(node => node.dataset.blockId === event.detail?.blockId);
          if (source) { this.editorCampaign = source.dataset.campaignSource; this.update(); }
        }, { signal });
        document.addEventListener('shopify:block:deselect', () => { this.editorCampaign = null; this.update(); }, { signal });
        queueMicrotask(this.refresh);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.originals?.forEach((original, target) => {
          if (!target.isConnected) return;
          target.replaceChildren(original.content.cloneNode(true));
          original.attributes.forEach(([name, value]) => value === null ? target.removeAttribute(name) : target.setAttribute(name, value));
          delete target.dataset.hfCampaign;
        });
      }
      remember(target) {
        if (this.originals.has(target)) return;
        const content = document.createDocumentFragment();
        [...target.childNodes].forEach(node => content.append(node.cloneNode(true)));
        this.originals.set(target, { content, attributes: ['href', 'aria-label'].map(name => [name, target.getAttribute(name)]) });
      }
      update() {
        if (!this.isConnected) return;
        const schedule = window.HFSeasonalSchedule?.state;
        if (!schedule) return;
        const sources = [...this.querySelectorAll('[data-campaign-source]')];
        const candidates = this.editorCampaign ? [this.editorCampaign] : schedule.campaigns;
        const source = candidates?.map(key => sources.find(node => node.dataset.campaignSource === key)).find(Boolean);
        const host = this.querySelector('[data-campaign-host]');
        if (!host) return;
        if (!source) { host.hidden = true; return; }
        const key = source.dataset.campaignSource;
        const focused = document.activeElement;
        const protectedTargets = [host, ...document.querySelectorAll('[data-hf-home-tile="seasonal"], [data-hf-seasonal-shelf]')];
        if (protectedTargets.some(target => target.contains(focused)) && host.dataset.hfCampaign !== key) return;
        if (host.dataset.hfCampaign !== key) {
          host.replaceChildren(source.content.querySelector('[data-campaign-spotlight]').content.cloneNode(true));
          host.dataset.hfCampaign = key;
        }
        host.hidden = false;
        this.dataset.activeCampaign = key;
        const early = host.querySelector('[data-campaign-early]');
        const christmas = sources.find(node => node.dataset.campaignSource === 'christmas');
        if (early) {
          early.hidden = key === 'christmas' || !christmas || !schedule.campaigns.includes('christmas');
          if (!early.hidden) early.href = christmas.dataset.url;
        }
        document.querySelectorAll('[data-hf-home-tile="seasonal"]').forEach(tile => {
          if (tile.dataset.hfCampaign === key) return;
          this.remember(tile);
          tile.replaceChildren(source.content.querySelector('[data-campaign-hero]').content.cloneNode(true));
          tile.dataset.hfCampaign = key;
        });
        document.querySelectorAll('[data-hf-seasonal-shelf]').forEach(panel => {
          if (panel.dataset.hfCampaign === key) return;
          this.remember(panel);
          const content = source.content.querySelector('[data-campaign-shelf]').content.cloneNode(true);
          if (panel.hidden) {
            const deferred = document.createElement('template');
            deferred.dataset.campaignDeferred = '';
            deferred.content.append(content);
            panel.replaceChildren(deferred);
          } else panel.replaceChildren(content);
          panel.dataset.hfCampaign = key;
          const tab = document.getElementById(panel.getAttribute('aria-labelledby'));
          if (tab) { this.remember(tab); tab.textContent = source.dataset.label; }
        });
        const birthday = document.querySelector('hf-monthly-birthdays');
        document.querySelectorAll('[data-hf-home-tile="birthday"]').forEach(tile => {
          const link = tile.querySelector('a');
          const label = tile.querySelector('strong');
          if (!link || !label) return;
          this.remember(link);
          const monthNumber = Number(birthday?.dataset.activeMonth) || Number(schedule.date.slice(5, 7));
          const month = new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', { month:'long', timeZone:'UTC' }).format(new Date(Date.UTC(2024, monthNumber - 1, 15)));
          const text = this.dataset.monthLabel.replace('[month]', month);
          label.textContent = text;
          link.setAttribute('aria-label', text);
          if (birthday && !birthday.hidden) link.href = '#' + birthday.id;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hf-wedding-gifts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hf-wedding-gifts')) {
    customElements.define('hf-wedding-gifts', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.choices = Array.from(this.querySelectorAll('[data-wedding-choice]'));
        this.panels = Array.from(this.querySelectorAll('[data-wedding-panel]'));
        const choiceList = this.querySelector('[data-wedding-choices]');
        if (!choiceList || !this.choices.length || this.choices.length !== this.panels.length) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        choiceList.setAttribute('role', 'tablist');
        this.choices.forEach((choice, index) => {
          choice.setAttribute('role', 'tab');
          choice.setAttribute('aria-controls', choice.dataset.panelId);
          choice.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
            event.preventDefault();
            this.select(index);
          }, options);
          choice.addEventListener('keydown', (event) => {
            if (event.altKey || event.ctrlKey || event.metaKey) return;
            const rtl = getComputedStyle(this).direction === 'rtl';
            const forward = rtl ? 'ArrowLeft' : 'ArrowRight';
            const backward = rtl ? 'ArrowRight' : 'ArrowLeft';
            let next = index;
            if (event.key === forward) next = (index + 1) % this.choices.length;
            else if (event.key === backward) next = (index - 1 + this.choices.length) % this.choices.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.choices.length - 1;
            else if (event.key !== ' ') return;
            event.preventDefault();
            this.select(next);
            this.choices[next].focus({ preventScroll: true });
          }, options);
        });
        this.panels.forEach((panel, index) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.choices[index].id);
          panel.removeAttribute('hidden');
        });
        this.classList.add('is-enhanced');
        const initial = this.choices.findIndex((choice) => choice.dataset.weddingChoice === this.dataset.initialRecipient);
        this.select(initial < 0 ? 0 : initial);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.choices.findIndex((choice) => choice.dataset.weddingChoice === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, options);
      }
      select(index) {
        this.choices.forEach((choice, position) => {
          const active = position === index;
          choice.setAttribute('aria-selected', String(active));
          choice.tabIndex = active ? 0 : -1;
          const panel = this.panels[position];
          panel.toggleAttribute('data-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
